import { Injectable } from '@angular/core';
import { ApplicationConfig } from '@frontend-site/shared/data';
import { VOID } from '@frontend-site/shared/utils';
import { filter, forkJoin, Observable, switchMap } from 'rxjs';
import { ProjectService } from './project/project.service';
import { ReleaseService } from './release/release.service';
import { SessionRepository } from './session/session.repository';
import { SystemService } from './system/system.service';
import { ScreenSizeService } from './screen-size/screen-size.service';
import { UserGroupsService } from './group';

@Injectable({ providedIn: 'root' })
export class AppInitializeService {
    constructor(
        private readonly session: SessionRepository,
        private readonly systemService: SystemService,
        private readonly projectService: ProjectService,
        private readonly releaseService: ReleaseService,
        private readonly screenSizeService: ScreenSizeService,
        private userGroupsService: UserGroupsService
    ) {}

    init(): Observable<void> {
        this.screenSizeService.init();

        return this.session.applicationConfig$.pipe(
            filter((appConfig: any) => !!appConfig),
            switchMap((appConfig: any) =>
                forkJoin([
                    this.systemService.loadSystems(),
                    this.projectService.loadProjects(),
                    this.releaseService.loadReleases((appConfig as ApplicationConfig).companyId),
                    this.userGroupsService.loadUserGroups(appConfig.companyId)
                ])
            ),
            switchMap(() => VOID)
        );
    }
}
